<template>
  <div class="q-pa-md">
    <div class="fit column wrap items-start content-center">
      <div class="text-h5 text-grey-7 self-center text-weight-bold">
        {{ t("common.signin") }}
      </div>

      <div class="q-pt-md" />

      <q-card
        flat
        bordered
        class="login-card q-py-lg q-mx-auto"
        align="center"
        style="width: 60em"
      >
        <!-- https://developers.google.com/identity/branding-guidelines -->
        <q-card-section>
          <div class="login-buttons">
            <div class="q-pb-md" style="cursor: pointer">
              <q-img
                no-spinner
                :src="googleButtonSrcLink"
                no-transition
                width="15em"
                @click="login"
                @mouseover="googleButtonMouseOver = true"
                @mouseleave="googleButtonMouseOver = false"
              />
            </div>
          </div>
        </q-card-section>

        <q-separator />

        <q-card-section class="column">
          <email-login />
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { AuthModule } from "@/store/modules/auth";
import EmailLogin from "@/components/auth/EmailLogin.vue";
import {
  AuthCodeFlowErrorResponse,
  AuthCodeFlowSuccessResponse,
  useTokenClient,
} from "vue3-google-signin";

// i18n
const { t } = useI18n();

// Router
const router = useRouter();

// State
const googleButtonMouseOver = ref(false);
const googleButtonSrcLink = ref("btn_google_signin_light_normal_web@2x.png");

// Helpers
function updateGoogleButtonSrcLink() {
  if (AuthModule.isDarkMode) {
    googleButtonSrcLink.value = googleButtonMouseOver.value
      ? "btn_google_signin_dark_pressed_web@2x.png"
      : "btn_google_signin_dark_normal_web@2x.png";
  } else {
    googleButtonSrcLink.value = googleButtonMouseOver.value
      ? "btn_google_signin_light_pressed_web@2x.png"
      : "btn_google_signin_light_normal_web@2x.png";
  }
}

// Initial call
updateGoogleButtonSrcLink();

// Watchers
watch(
  [() => AuthModule.getDarkMode(), googleButtonMouseOver],
  updateGoogleButtonSrcLink,
);

// Google Login callbacks
const handleOnLoginSuccess = async (response: AuthCodeFlowSuccessResponse) => {
  try {
    const result = await AuthModule.obtainTokenWithGoogle({
      access_token: response.access_token,
    });
    console.log("Login successful: ", result);

    await AuthModule.postLogin();
    await router.push({ name: "Course", replace: true });
  } catch (error) {
    console.error("Login failed: ", error);
    return Promise.reject(error);
  }
};

const handleOnLoginError = (errorResponse: AuthCodeFlowErrorResponse) => {
  console.log("Login Error: ", errorResponse);
};

// Google Login trigger
const { login } = useTokenClient({
  onSuccess: handleOnLoginSuccess,
  onError: handleOnLoginError,
});
</script>
